export function* manufacturerSaga() {}
